import React from "react";
import Loader from "components/Loader";
import OutlinedButton from "components/common/Button/OutlinedButton";
import { Input } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { t } from "i18next";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import axiosInstance from "utils/axios";
import { formatMessage } from "utils/utility";
import { decrypt } from "utils/crypto";
import { useUserAuth } from "context/authProvider";

const VerifyPhone = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [timer, setTimer] = React.useState(30);
  const [inputVales, setInputValues] = React.useState({
    code: "",
    error: "",
    success: "",
    loading: false,
  });
  const { setUser } = useUserAuth();

  const { dir } = useAppSelector(getSettings);

  const onChange = (text) => {
    console.log("onChange:", text, "Length:", text?.length);
    setInputValues(prev => ({ ...prev, code: text || "" }));
  };

  React.useEffect(() => {
    let timerVar = setInterval(() => {
      if (timer > 0) setTimer(timer - 1);
      else {
        clearInterval(timerVar);
      }
    }, 1000);
    return () => {
      clearInterval(timerVar);
    };
  }, [timer]);

  React.useEffect(() => {
    console.log("State changed:", inputVales.code, "Length:", inputVales.code?.length);
  }, [inputVales.code]);


  function handleSubmit() {
    setInputValues({ ...inputVales, loading: true });
    axiosInstance
      .post(`users/verify-otp`, {
        otp: inputVales.code,
        phone_number: sessionStorage.getItem("phone_number")
          ? sessionStorage.getItem("phone_number")
          : state?.phone_number ?? "phone number",
        session_id: Number(sessionStorage.getItem("session") ?? ""),
      })
      .then((res) => res.data)
      .then((data) => {
        if (data.statusCode === 200) {
          setInputValues({
            ...inputVales,
            error: "",
            loading: false,
            success: "",
          });

          const decDetails = decrypt(data.data);
          setUser(decDetails.token);
          localStorage.setItem("token", decDetails.token);
          localStorage.setItem("session", decDetails.session_id);
        } else {
          setInputValues({
            ...inputVales,
            error: formatMessage(data.data.message),
            loading: false,
            success: "",
          });
        }
      })
      .catch((err) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(
            err?.response?.data?.message ?? "someThingWentWrong"
          ),
          loading: false,
          success: "",
        });
      });
  }

  function handleResendCode() {
    if (timer > 0) return;
    setInputValues({ ...inputVales, loading: true });
    axiosInstance
      .post(`users/resend-otp`, {
        phone_number: sessionStorage.getItem("phone_number")
          ? sessionStorage.getItem("phone_number")
          : state?.phone_number ?? "phone number",
      })
      .then((res) => res.data)
      .then((data) => {
        if (data.statusCode === 200) {
          setInputValues({
            ...inputVales,
            error: "",
            success: formatMessage(data.message),
            loading: false,
          });
          setTimer(30);
        } else {
          setInputValues({
            ...inputVales,
            error: formatMessage(data.message),
            loading: false,
            success: "",
          });
        }
      })
      .catch((err) => {
        setInputValues({
          ...inputVales,
          error: formatMessage(
            err?.response?.data?.message ?? "someThingWentWrong"
          ),
          loading: false,
          success: "",
        });
      });
  }

  return (
    <>
      <Loader open={inputVales.loading} position="portal" />
      <div className="flex flex-col max-w-sm w-full px-6 md:px-0" dir={dir}>
        <div className="flex flex-col gap-4 mb-6">
          <p className="text-base text-gray-700 w-full text-center mb-6">
            {/* Check&nbsp;
            {sessionStorage.getItem("email")
              ? sessionStorage.getItem("email")
              : state?.email ?? "email"}&nbsp;
            for code */}
            {t("otpTitle", {
              phoneNumber: sessionStorage.getItem("phone_number")
                ? sessionStorage.getItem("phone_number")
                : state?.phone_number ?? "phone number",
            })}
            <button
              className="underline mx-3 text-gray-600 hover:text-gray-800 transition-colors"
              onClick={() => {
                navigate(-1);
              }}
            >
              {t("changeNumber")}
            </button>
          </p>
          {inputVales.error && (
            <p className="text-red-500 text-xs italic">
              {inputVales.error ?? t("someThingWentWrong")}
            </p>
          )}
          {inputVales.success && (
            <p className="text-green-500 text-xs italic">
              {inputVales.success ?? "Code sent successfully!"}
            </p>
          )}
          {/* <Input
            id="verfiy-email"
            type="number"
            placeholder="XXX-XXX"
            value={inputVales.code}
            onChange={(e) => {
              const regex = /^\d{0,6}$/;
              if (regex.test(e.target.value))
                setInputValues({ ...inputVales, code: e.target.value });
            }}
            className="text-lg py-1"
          /> */}
          <Input
            type="text"
            maxLength={6}
            value={inputVales.code}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ''); // Only allow digits
              console.log("Input onChange:", value);
              setInputValues(prev => ({ ...prev, code: value }));
            }}
            placeholder="XXX-XXX"
            className="text-center text-2xl tracking-widest"
            dir="ltr"
          />
        </div>
        <div className="flex flex-col gap-3 items-center justify-center w-full">
          <OutlinedButton
            onClick={handleSubmit}
            disabled={!inputVales.code || inputVales.code.length < 6}
            className="disabled:opacity-50 w-full py-3 px-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white border-blue-600 hover:from-blue-600 hover:to-blue-700 hover:border-blue-700 transition-all duration-200 font-semibold text-base rounded-lg shadow-md hover:shadow-lg flex items-center justify-center"
          >
            {t("otpPageVerifyButon")}
          </OutlinedButton>
          <button
            className={`text-gray-600 underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm disabled:opacity-50 ${
              timer > 0 ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            onClick={handleResendCode}
            disabled={timer > 0}
          >
            {t("otpPageSendAgainText")} {timer} {t("otpPageSecondsCountText")}
          </button>
        </div>
      </div>
    </>
  );
};

export default VerifyPhone;
